module.exports = __webpack_public_path__ + "static/img/06_車内アルコール@2x.bf599bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/06_車内アルコール@2x.png
// module id = 4gFY
// module chunks = 0